<template>
  <div class="home">
    <div class="columns is-centered">
      <div class="column is-three-fifths">
          <div class="messages">
              <div v-for="message in messages">
                  <div class="messageContainer">
                      <b-message type="is-warning">
                          <span>{{message}}</span>
                      </b-message>
                  </div>
              </div>
          </div>
          <div class="body-controls">
              <div v-if="isLoading">
                  <loader></loader>
              </div>
              <div v-else-if="noCurrentPatient">
                  <h1 class="title">Start serving patients</h1>
                  <p>You are currently not entertaining a patient</p>
                  <b-button type="is-primary" rounded size="is-medium" @click="nexter">Entertain a Patient</b-button>
              </div>
              <div v-else>
                  <current-patient :tel="currentPatient" :call-code="callCode"></current-patient>
                  <b-button
                    type="is-primary"
                    rounded size="is-medium"
                    tag="a" target="_blank"
                    href="https://micahealth.daily.co">
                        Create Video Call Room →
                </b-button>
                  <div class="buttons">
                      <b-button @click="nexter">Next Patient</b-button>
                      <b-button @click="ender">Exit Clinic</b-button>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import CurrentPatient from "../components/currentPatient";
import BButton from "buefy/src/components/button/Button";
import Loader from "../components/loader";
export default {
  name: 'Home',
    components: {Loader, BButton, CurrentPatient},
    data() {
      return {
          currentPatient: null,
          callCode: null,
          messages: [],
          isLoading: false,
          noCurrentPatient: false
      }
    },
    methods: {
        promptLogin() {
          this.$router.push({name: 'Login'})
        },
        getCurrentPatient() {
          const vm = this;
          vm.isLoading = true;
          vm.axios.get(`${vm.$host}/users/${localStorage.user}/currentPatients?access_token=${localStorage.token}`)
              .then(function (res) {
                  vm.isLoading = false;
                  vm.currentPatient = res.data.tel;
                  vm.callCode = res.data.callCode;
              })
              .catch(function (err) {
                  if (err.response.status === 401) {
                      vm.promptLogin()
                  } else if (err.response.status === 404) {
                      vm.isLoading = false;
                      vm.noCurrentPatient = true;
                  } else {
                      alert(err)
                  }
              })
        },
        nexter() {
            const vm = this;
            vm.isLoading = true;
            vm.noCurrentPatient = false;
            vm.messages = [];
            vm.axios.post(`${vm.$host}/lista/nexter?access_token=${localStorage.token}`)
                .then(function (res) {
                    vm.isLoading = false;
                    if (res.data.currentPatient === null) {
                        vm.noCurrentPatient = true;
                    } else {
                        vm.currentPatient = res.data.currentPatient;
                        vm.callCode = res.data.callCode;
                    }
                    vm.messages = res.data.messages;
                })
                .catch(function (err) {
                    if (err.response.status === 401) {
                        vm.promptLogin()
                    } else {
                        alert(err)
                    }
                })
        },
        ender() {
            const vm = this;
            vm.isLoading = true;
            vm.noCurrentPatient = false;
            vm.axios.delete(`${vm.$host}/currentPatients/${vm.callCode}?access_token=${localStorage.token}`)
                .then(function (res) {
                    vm.isLoading = false;
                    vm.messages = [];
                    vm.noCurrentPatient = true;
                    vm.currentPatient = null;
                    vm.callCode = null
                })
                .catch(function (err) {
                    vm.isLoading = false;
                    alert(err)
                })
        }
    },
    mounted() {
      if (!localStorage.token) {
          this.promptLogin()
      } else {
          this.getCurrentPatient()
      }
    }
}
</script>
